import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h3 } from '@helpers/typography';
import ArticleCardStyles from '@stories/Components/Cards/ArticleCard/ArticleCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import LatestArticlesStyles from '@stories/Widgets/Aggregation/LatestArticles/LatestArticles.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  
`;
const Inner = styled.div `
  ${baseGrid}
  align-items: flex-start;
  row-gap: 16px;
`;
const ContentWrapper = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.TabletLarge)} {
    grid-row: 1;
    grid-column: 1 / span 6;
  }
`;
const Title = styled.h2 `
  ${h3}
`;
const Content = styled.div `
  ${contentStyles}
`;
const MediaColumn = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.TabletLarge)} {
    grid-column: 8 / span 5;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-row: 1;
    grid-column: 9 / span 4;
  }

  ${SectionWrapperStyles.SiteWide} {
    padding: 0;
  }

  ${SectionWrapperStyles.Inner} {
    padding: 0;
  }

  ${LatestArticlesStyles.Title} {
    margin-bottom: 0;
    text-align: left;
  }

  ${LatestArticlesStyles.CtaWrapper} {
    margin-top: 20px;
  }

  ${ArticleCardStyles.ContentWrapper} {
    background-color: ${brand.lightGrey};
  }  
`;
const CtaOverlay = styled.a `
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 16px;
  right: 16px;
  background-color: ${brand.green.mid};
  color: currentColor;
  text-decoration: none;
  width: 21%;
  height: 27.8%;
  min-width: 68px;
  min-height: 68px;
  max-width: 156px;
  max-height: 156px;
  border-radius: 50%;
`;
const CtaOverlayText = styled.span `
  --font-clamp: clamp(0.7rem, 2.5vw, 22px);

  ${fonts.montserrat.extraBold};
  font-size: var(--font-clamp);
  line-height: 1.2;
  text-align: center;
  max-width: 86%;

  @media ${from(Device.TabletLarge)} {
    --font-clamp: clamp(1rem, 1.5vw, 22px);
  }
`;
const CtaWrapper = styled.div `
  margin-top: 40px;
`;
const MediaArticleIntroStyles = {
    Container,
    Content,
    ContentWrapper,
    Inner,
    MediaColumn,
    Title,
    CtaOverlay,
    CtaOverlayText,
    CtaWrapper,
};
export default MediaArticleIntroStyles;
